import React from 'react'
import moment from 'moment'

import Pagination from 'app/views/components/Pagination'
import LicenseTag from 'app/views/components/LicenseTag'

import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'

class UsersList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedUser: {},
    }
    this.onSelectUser = this.onSelectUser.bind(this)
    this.renderLicense = this.renderLicense.bind(this)
    this.printRole = this.printRole.bind(this)
  }

  onSelectUser(user) {
    this.props.onSelectUser(user)
  }

  printRole(role) {
    switch (role) {
      case 'admin':
        return 'Admin'
      case 'team_admin':
        return 'Team Admin'
      default:
        return 'Member'
    }
  }

  renderLicense(user) {
    if (user.has_license && user.expiration_date && getLocalDateFromUTC(user.expiration_date).diff(moment(), 'seconds') < 0) {
      return <span className="uk-label uk-label-danger">Expired</span>
    }
    if (user.has_license) {
      return <span className="uk-label uk-label-success">{user.license_type}</span>
    }
    return <span className="uk-label uk-label-danger">No license</span>
  }

  render() {
    return (
      <>
        <h2>
          Users
          <button
            onClick={this.props.showAddUsers}
            className="uk-button uk-button-primary uk-button-small uk-align-right uk-margin-small-left"
            type="button"
          >
            <span className="uk-margin-small-right" data-uk-icon="plus-circle" />
            Add Users
          </button>
          <button
            onClick={() => this.props.onExport()}
            className="uk-button uk-button-default uk-button-small uk-align-right uk-margin-small-left"
            type="button"
          >
            <span className="uk-margin-small-right" data-uk-icon="cloud-download" />
            Export Data
          </button>
        </h2>

        <div
          className="uk-width-1-1"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className="uk-inline">
            <a className="uk-form-icon" href="#" uk-icon="icon: search"></a>
            <input
              className="uk-input uk-form-width-large"
              type="text"
              placeholder="Search by email"
              spellCheck={false}
              value={this.props.filterHacker}
              onChange={this.props.onChangeFilter}
            />
            {this.props.filterHacker !== '' && (
              <a
                role="button"
                onClick={this.onClearFilter}
                style={{
                  cursor: 'pointer',
                }}
                className="uk-form-icon uk-form-icon-flip"
                uk-icon="icon: close"
              />
            )}
          </div>
          <Pagination
            onChangePage={this.props.onChangePage}
            hasArrows
            totalPages={this.props.totalPages}
            currentPage={this.props.offsetHackers === 0 ? 1 : (this.props.offsetHackers / this.props.hackersPerPage) + 1}
          />
        </div>
        <table className="uk-table uk-table-divider uk-table-responsive uk-table-middle">
          <thead>
            <tr>
              <th>
                Email
              </th>
              <th>
                Role
              </th>
              <th>
                Teams
              </th>
              <th className="uk-text-center">
                License
              </th>
              <th>
                Progress
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {this.props.users.length === 0 && (
              <tr>
                <td colSpan="5" className="uk-text-center">
                  {this.props.filterHacker !== '' ? 'There are no users that coincide with your search criteria' : 'No users in the organization'}
                </td>
              </tr>
            )}
            {this.props.users.map((user) => (
              <tr
                key={user.uuid}
              >
                <td>
                  <a
                    role="button"
                    onClick={() => {
                      this.props.fetchSelectedUserDetail(this.props.match.params.organization_uuid, user)
                    }}>
                    {user.email}
                  </a>
                </td>
                <td>{this.printRole(user.role)}</td>
                <td>
                  {user.teams.length === 0 ? ' - ' : user.teams.sort((a, b) => {
                    if (a.name > b.name) {
                      return 1
                    }
                    if (a.name < b.name) {
                      return -1
                    }
                    return 0
                  }).map((team) => (
                    <div key={team.uuid}>
                      <span className="uk-label uk-label-secondary">{team.name}</span>
                    </div>
                  ))}
                </td>
                <td className="uk-text-center">
                  <LicenseTag user={user} />
                </td>
                <td>
                  <progress className="uk-progress" value={user.progress} max="100" />
                </td>
                <td>
                  <button
                    onClick={this.onSelectUser.bind(this, user)}
                    type="button"
                    className="uk-button uk-button-primary uk-button-small"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </>
    )
  }
}

export default UsersList
